
export const FORM_ACTIONS = {
  VER: 'VER',
  CREAR: 'CREAR',
  MODIFICAR: 'MODIFICAR',
};

export const diasSemana = [
  { display: 'Lunes', value: 'LU', value2: 'lunes' },
  { display: 'Martes', value: 'MA', value2: 'martes' },
  { display: 'Miércoles', value: 'MI', value2: 'miercoles' },
  { display: 'Jueves', value: 'JU', value2: 'jueves' },
  { display: 'Viernes', value: 'VI', value2: 'viernes' },
  { display: 'Sábado', value: 'SA', value2: 'sabado' },
  { display: 'Domingo', value: 'DO', value2: 'domingo' },
];

export const AREAS_USUARIOS = {
  SECCIONAL: 1,
  NACIONAL: 2,
  RECURSOS_HUMANOS: 3,
  CONTRATACIONES: 4,
  LEGALES: 5,
  CENTROS_MEDICOS: 6,
  COMUNICACIONES: 8,
  LIQUIDACIONES: 9,
  AUTORIZACIONES_NACIONAL: 10,
  TOTEM: 17,
  DISCAPACIDAD: 18,
  MESA_ENTRADA: 19,
  COMPRAS: 20,
  MESA_DE_AYUDA: 21,
  AUTORIZACIONES_SECCIONAL: 22
};

export const SUB_AREAS_CONTRATACIONES = {
  COMPLETA: 1,
  RRHH: 2,
  LEGALES: 3,
};

export const TIPO_PARAMETRIZACION_TURNOS = {
  NORMAL: 1,
  EVENTUAL: 2,
};

export const FRECUENCIA_TURNOS = {
  DIARIO: 1,
  SEMANAL: 2,
  QUINCENAL: 3,
  MENSUAL: 4,
};

export const SITUACION_REVISTA = {
  RELACION_DE_DEPENDENCIA: 0,
  PASANTES: 1,
  JUBILADOS_DEL_SISTEMA_NACIONAL_DEL_SEGURO_DE_SALUD: 2,
  ADHERENTES_VOLUNTARIOS: 3,
  MONOTRIBUTISTA: 4,
  SERVICIO_DOMESTICO: 5,
  MONOTRIBUTISTA_SOCIAL: 7,
  SEGURO_DESEMPLEO: 8,
  RELACION_DE_DEPENDENCIA_SIN_APORTES: 12,
};
export const TIPO_AFILIACION = {
  DJ: 1,
  TRASPASO: 2,
  TEMPORARIO_CON_CUOTA: 4,
  TEMPORARIO: 57,
  PASANTE: 62,
  ADHERENTE: 63,
  JUBILADOS_NACIONAL: 64,
  JUBILADOS_ESPANOLES: 65,
  JUBILADOS_PENSIONADOS_OTROS_SISTEMAS: 66,
  FONDO_DESEMPLEO: 67,
  FONDO_DESEMPLEO_RENATRE: 68,
  SERVICIO_DOMESTICO: 69,
  MONOTRIBUTISTA_SOCIAL: 70,
  MONOTRIBUTISTA: 71,
  EMPADRONADO: 72,
  TRASPASO_MR: 73,
};
export const PARENTESCOS = {
  TITULAR: 0,
  CONYUGE: 1,
  CONCUBINA_O: 2,
  HIJO_MENOR: 3,
  HIJO_ESTUDIANTE: 4,
  FAMILIAR_A_CARGO: 5,
  HIJO_DISCAPACITADO: 6,
  MENOR_BAJO_GUARDA_O_TUTELA: 7,
  HIJO_CONYUGE: 8,
  HIJO_CONYUGE_ESTUDIANTE: 9,
};
export const SEXO = {
  MASCULINO: 1,
  FEMENINO: 2,
  NO_INFORMADO: 3,
  NO_BINARIO: 4,
};
export const TIPO_DOCUMENTO = {
  DNI: 1,
  CEDULA_IDENTIDAD: 2,
  LIBRETA_ENROLAMIENTO: 3,
  LIBRETA_CIVICA: 4,
  PASAPORTE: 5,
  NI: 6,
  RN: 7,
};
export const ESTADOS_CIVILES = {
  CASADO: 1,
  SOLTERO: 2,
  SEPARADO: 3,
  DIVORCIADO: 4,
  VIUDO: 5,
  CONCUBINO: 6,
  OTRO: 7,
};

export const TIPO_CERTIFICADOS = {
  ESTUDIO: 1,
  DISCAPACIDAD: 2,
  PMI: 3,
};

export const CENTROS_MEDICOS_PROPIOS = {
  TALIANO: 1,
  ESCOBAR: 2,
  TIGRE: 3,
  CORDOBA_CAPITAL: 4,
  LA_PLATA: 6,
  SANTA_FE: 7,
  DORREGO_MDQ: 8,
  URQUIZA_ENTRE_RIOS: 9,
  SALTA: 10,
  PUNILLA_CORDOBA: 12,
  MORON: 13,
  BONJOUR_LOMAS_DE_ZAMORA: 14,
  VARELA_BERAZATEGUI: 15,
};

export const TAMANO_IMAGENES = {
  CERTIFICADOS: 3072 * 1024,
  DOCUMENTACION_AFILIADOS: 3072 * 1024,
  FOTO_USUARIO: 3072 * 1024,
  DOCUMENTACION_AUTORIZACIONES: 5120 * 1024,
  DOCUMENTACION_EMPADRONAMIENTO: 5120 * 1024,
};

export const MOTIVO_TURNOS = {
  CANCELADO_POR_AFILIADO: 1,
};

export const ESTADOS_EFECTOR = {
  ACTIVO: 1,
  PASIVO: 2,
};

export const CATEGORIAS_TIPO_DOCUMENTACION = {
  DATOS_PERSONALES: 1,
  EMPRESA: 2,
  DATOS_LEGALES: 3,
};

export const TIPO_TURNO = {
  PRESENCIAL: 1,
  VIRTUAL: 2,
  AMBOS: 3,
};

export const TIPO_FERIADO = {
  FERIADO_NACIONAL: 1,
  FERIADO_PROVINCIAL: 2,
  FERIADO_CIUDAD: 3,
};

export const TIPO_COMPROBANTE = {
  FACTURA: 1,
  NOTA_CREDITO: 2,
  PRESUPUESTO: 3,
  NOTA_DEBITO: 4,
  RECIBO: 5,
  PROFORMA: 6,
  COTIZACION: 7,
};

export const SUBTIPO_EFECTORES = {
  ENTIDADES_INTERMEDIAS_PROFESIONALES: 2,
  PROFESIONALES_CENTROS_AJENOS: 6,
  PROFESIONALES_CENTROS_PROPIOS: 7,
  ENTIDADES_INTERMEDIAS_ESTABLECIMIENTOS_REDES_GERENCIADORAS: 8,
  PERSONAS_JURIDICAS: 9,
  EVENTUAL: 10,
  FARMACIA: 11,
  HOSPITAL: 12,
  INTEGRACION: 13,
  NO_RECUPERABLES: 14,
  ADICCION: 15,
  ENFERMERIA: 16,
  PROVEEDOR: 17,
  COMPRAS_MEDICAS: 18,
};

export const NOMENCLADORES = {
  NOMENCLADOR_OSPEDYC: 1,
  NOMENCLADOR_HOSPITALES_CABA: 2,
  NOMENCLADOR_HOSPITALES_PUBLIC: 3,
  NOMENCLADOR_ODONTOLOGICO: 4,
  NOMENCLADOR_GARRAHAN: 5,
  SIN_DENOMINACION: 6,
};

export const TIPO_EFECTORES = {
  //tipo contratos
  CONTRATO_PRESTADORES: 1,
  INTEGRACION: 2,
  PROVEEDOR: 3,
};

export const TIPO_CONTACTO_EFECTOR = {
  LEGAL: 1,
  FACTURACION: 3,
  COMERCIAL: 4,
  TESORERIA: 5,
  DIRECCION_MEDICA: 6,
  AUDITORIA: 7,
  ADMISIONES_INTERNACION: 8,
  NO_INDICA: 9,
};

export const TIPO_MATRICULA = {
  MATRICULA_NACIONAL: 1,
  MATRICULA_PROVINCIAL: 2,
  MATRICULA_MUNICIPAL: 3,
};

export const TIPOS_ARCHIVOS_MIGRACION = {
  PADRON_SSS: 6,
  NOVEDADES_SSS: 9,

  BAJAS: 17,
  CAPITA_DESEMPLEO: 5,
  CAPITA_JUBILADOS: 4,
  DDJJ: 1,
  DEVOLUCIONES_SSS: 8,
  ENVIO_PADRON_SSS: 11,
  PAGO_FACIL: 16,
  RELACIONES_LABORALES: 3,
  SANO: 12,
  SUBSIDIOS: 7,
  SUMA: 13,
  SUMA_70: 14,
  SUMARTE: 15,
  TRANSFERENCIAS: 2,
  BAJAS_POR_TRASPASO: 18
};

export const TIPOS_ARCHIVOS_CONTRATACIONES = {
  CMP: 1,
  EQUIVALENCIAS: 2,
  MODULOS: 3,
};

export const MENU_CONTRATACIONES = {
  CONSULTA: 1,
  INGRESO: 2,
};

export const MENU_PROVEEDORES = {
  CONSULTA: 1,
  INGRESO: 2,
};

export const VERSIONADO = {
  VERSION_ACTUAL: 'v2025.07.02',
};

export const BUSCADOR_CENTRAL = {
  CARACTERES_MINIMOS_AFILIACIONES: 2,
  MILISEG_SIN_CAMBIOS: 2000,
  CARACTERES_MINIMOS_TURNOS_EXTERNOS: 7,
  MILISEG_SIN_CAMBIOS_EXT: 1000,
  CARACTERES_MINIMOS_TURNOS_AUT: 4,
  MILISEG_SIN_CAMBIOS_AUT: 1500,
};

export const TIPO_PRACTICAS_POR_FECHA = {
  NO_VIGENTES: 1,
  VIGENTES: 2,
  FUTURAS: 3,
};

export const CATEGORIAS_VALORIZACIONES = {
  A: 1,
  B: 2,
  C: 3,
  BASICA: 4,
  D: 5,
  ND: 6,
};

export const CATEGORIAS_VALORIZACIONES_ARRAY = [
  { id: CATEGORIAS_VALORIZACIONES.BASICA, descripcion: "Basica" },
  { id: CATEGORIAS_VALORIZACIONES.A, descripcion: "A" },
  { id: CATEGORIAS_VALORIZACIONES.B, descripcion: "B" },
  { id: CATEGORIAS_VALORIZACIONES.C, descripcion: "C" },
  { id: CATEGORIAS_VALORIZACIONES.D, descripcion: "D" },
  { id: CATEGORIAS_VALORIZACIONES.ND, descripcion: "N/D" }
];

export const TIPOS_VALORIZACIONES = {
  VALOR_FIJO: 1,
  NBU: 2,
  NNX: 3,
  GALENOS_GASTOS: 4,
};

export const CAT_HONGAS_VALORIZACIONES = {
  H: 1,
  G: 2,
  HG: 3,
};

export const CARTILLAS = {
  ADICCIONES_DISCAPACIDAD: 23,
};

export const TIPO_NOTIFICACIONES = {
  APP: 1,
  EMAIL: 2,
  SMS: 3,
};

export const RANKINGS_CARTILLA = {
  CM_PROPIO: 1,
};

export const MENU_LIQUIDACIONES = {
  GESTION_FACTURAS: 1,
  CARGA_ARCHIVO_HELIOS: 2,
  GENERACION_VOUCHERS: 3,
  CARGA_ARCHIVO_SCIENZA: 4,
  CONSULTA_EXPEDIENTES: 5
};

export const LIQUIDACIONES_COMPROBANTES_ESTADOS = {
  PENDIENTE_CARGA: 3, //en MesaEntradas es Enviada
  // ENVIADA: 3,         //ESTE ESTADO ES CUANDO SE RETORNO EL COMPROBANTE
  PENDIENTE_LIQUIDACION: 4,
  RETORNADA: 14,
  PENDIENTE_SOLICITUD_PAGO: 5,
  PENDIENTE_ENVIO_TESORERIA: 6,
  ENVIADA_TESORERIA: 7,
  // RETORNADA: 8,
  ANULADA: 2,
  PAGADA: 9,
  PROFORMAS_PENDIENTES_CARGA: 10,

};

export const LIQUIDACIONES_TIPO_SOLICITUD_LINEA = {
  AUTORIZACION: 1,
  PRESUPUESTO: 3,
  SCIENZA: 2,
}

export const LIQUIDACIONES_LINEA_COMPORBANTE = {
  PRESTACION: 1,
  MEDICAMENTO: 2,
  INSUMO: 3,
};

export const LIQUIDACIONES_TIPO_INGRESO_LINEA = {
  CARGA_EXCEL: 1,
  CARGA_MANUAL: 2,
  CARGA_POR_IDSOLICITUD: 3,
};

export const PRACTICA_ERROR_SUMA = {
  ID_COD_NOM: 8685,
  COD_NOM: 'xx.xx.xx',
  DES_NOM: 'ERROR DE SUMA',
};

export const PRACTICA_PRORROGA_AUTOMATICA = {
  ID_COD_NOM: 8686,
  COD_NOM: 'yy.yy.yy',
  DES_NOM: 'PRORROGA AUTOMATICA',
};

export const PRACTICA_MEDICAMENTOS_EN_AMBULATORIO = {
  ID_COD_NOM: 8531,
  COD_NOM: '70.50.01',
  DES_NOM: 'MEDICAMENTOS EN AMBULATORIO',
};

export const PRACTICA_MEDICAMENTOS_DE_ALTO_COSTO = {
  ID_COD_NOM: 8539,
  COD_NOM: '70.50.09',
  DES_NOM: 'MEDICAMENTOS DE ALTO COSTO',
};

export const PRACTICA_MEDICAMENTOS_EN_INTERNACION = {
  ID_COD_NOM: 8532,
  COD_NOM: '70.50.02',
  DES_NOM: 'MEDICAMENTOS EN INTERNACION',
};

export const PRACTICA_EMPADRONAMIENTO = {
  ID_COD_NOM: 8811,
  COD_NOM: '80.50.15',
  DES_NOM: 'EMPADRONAMIENTO',
};

export const MENU_AUTORIZACIONES = {
  INGRESO_AUTORIZACION: 1,
  GESTION_AUDITORIA: 2,
  GESTION_PRESUPUESTOS: 3,
  SOLICITUDES_VIA_APP: 4,
  BUSCADOR: 5
};

export const STEPPER_AUTORIZACIONES = {
  BUSCAR_TITULAR: 0,
  DATOS_TITULAR: 1,
  DETALLES_ORDEN: 2,
  PRACTICAS: 3,
  CONFIRMACION: 4,
};

export const TIPOS_AUTORIZACIONES = {
  PRACTICAS: 1,
  MATERIALES_SIN_PRACTICAS: 2,
  PRACTICAS_DOMICILIARIAS: 3,
  PRESUPUESTOS: 4,
  TRASLADO: 5,
  DENUNCIA_INTERNACION: 6,
  DENUNCIA_INTERNACION_DOMICILIARIA: 7,
  DISCAPACIDAD: 8,
  PRACTICAS_EN_INTERNACION: 9,
  OXIGENO: 10,
  LABORATORIO: 11,
  PASAJES: 12,
  ESTADIAS: 13,
};

export const TIPOS_PRESUPUESTO = {
  CON_CONTRATO: 1,
  SIN_CONTRATO: 2,
};

export const PRACTICA_INSUMOS_AUTORIZACIONES = {
  ID_COD_NOM: 8576,
  COD_NOM: '80.50.06',
  DES_NOM: 'INSUMOS MEDICOS',
};

export const ESTADISTICAS_OSPEDYC = {
  INGRESOS_MOBILE: 1,
  INGRESOS_DESKTOP: 2,
  TIEMPO_DE_USO: 3,
  CREDENCIAL: 4,
  TURNOS: 5,
  CARTILLA: 6,
  FORMULARIOS: 7,
  FARMACIAS: 8,
  CONTACTOS: 9,
  DISCAPACIDAD: 10,
};

export const AUTORIZACIONES_SOLICITUDES_ESTADOS = {
  EN_CARGA: 1,
  PENDIENTE_EVALUACION_APP_HCE: 7,
  DEVOLUCION_APP: 8,
  DEVOLUCION: 3,
  PENDIENTE: 2,
  PRACTICAS_INTERNACION: 92, //SOLO PARA AGRUPAR idEstado Real = 2 PENDIENTE
  PENDIENTE_MATERIALES: 5,
  AUDITORIA_ADMINISTRATIVA: 6,
  INTERNACION_DOMICILIARIA: 94, //SOLO PARA AGRUPAR idEstado Real = 2 PENDIENTE
  AUDITORIA_TERRENO: 96, //SOLO PARA AGRUPAR idEstado Real = 2 PENDIENTE
  INTERNACION_PAIS: 97, //SOLO PARA AGRUPAR idEstado Real = 2 PENDIENTE
  PENDIENTE_COSEGURO: 93, //SOLO PARA AGRUPAR idEstado Real = 4 TERMINADA
  CANCELADA: 95, //SOLO PARA AGRUPAR idEstado Real = 4 TERMINADA
  RECHAZADA: 98, //SOLO PARA AGRUPAR idEstado Real = 4 TERMINADA
  AUTORIZADA: 99, //SOLO PARA AGRUPAR idEstado Real = 4 TERMINADA
  TERMINADA: 4,
  OXIGENO: 100 //SOLO PARA AGRUPAR idEstado Real = 2 PENDIENTE
};

export const AUTORIZACIONES_SOLICITUDES_ESTADOS_ARRAY = [
  { id: AUTORIZACIONES_SOLICITUDES_ESTADOS.EN_CARGA, descripcion: 'En carga' },
  { id: AUTORIZACIONES_SOLICITUDES_ESTADOS.PENDIENTE, descripcion: 'Pendiente' },
  { id: AUTORIZACIONES_SOLICITUDES_ESTADOS.DEVOLUCION, descripcion: 'Devolucion' },
  { id: AUTORIZACIONES_SOLICITUDES_ESTADOS.PENDIENTE_MATERIALES, descripcion: 'Pendiente Materiales' },
  { id: AUTORIZACIONES_SOLICITUDES_ESTADOS.AUDITORIA_ADMINISTRATIVA, descripcion: 'Auditoria Administrativa' },
  { id: AUTORIZACIONES_SOLICITUDES_ESTADOS.INTERNACION_DOMICILIARIA, descripcion: 'Internacion Domiciliaria' },
  { id: AUTORIZACIONES_SOLICITUDES_ESTADOS.AUDITORIA_TERRENO, descripcion: 'Auditoria Terreno' },
  { id: AUTORIZACIONES_SOLICITUDES_ESTADOS.INTERNACION_PAIS, descripcion: 'Internacion Pais' },
  { id: AUTORIZACIONES_SOLICITUDES_ESTADOS.TERMINADA, descripcion: 'Terminada' },
  { id: AUTORIZACIONES_SOLICITUDES_ESTADOS.PENDIENTE_COSEGURO, descripcion: 'Pendiente Coseguro' },
  { id: AUTORIZACIONES_SOLICITUDES_ESTADOS.CANCELADA, descripcion: 'Cancelada' },
  { id: AUTORIZACIONES_SOLICITUDES_ESTADOS.RECHAZADA, descripcion: 'Rechazada' },
  { id: AUTORIZACIONES_SOLICITUDES_ESTADOS.AUTORIZADA, descripcion: 'Autorizada' },
];

export const AUTORIZACIONES_PRESUPUESTOS_ESTADOS = {
  EN_CARGA: 1,
  DEVOLUCION: 7,
  PENDIENTE: 2,
  /*AUDITORIA: 3,*/
  PENDIENTE_CONTRATOS: 4,
  AUTORIZADO: 5,
  RECHAZADO: 6,
  COMPRAS: 99,
  AUTORIZADO_POR_COMPRAS: 98
};

export const AUTORIZACIONES_PRESUPUESTOS_ESTADOS_ARRAY = [
  { id: AUTORIZACIONES_PRESUPUESTOS_ESTADOS.EN_CARGA, descripcion: 'En carga' },
  { id: AUTORIZACIONES_PRESUPUESTOS_ESTADOS.DEVOLUCION, descripcion: 'Devolucion' },
  { id: AUTORIZACIONES_PRESUPUESTOS_ESTADOS.PENDIENTE, descripcion: 'Pendiente' },
  /*{ id: AUTORIZACIONES_PRESUPUESTOS_ESTADOS.AUDITORIA, descripcion: 'Auditoria' },*/
  { id: AUTORIZACIONES_PRESUPUESTOS_ESTADOS.PENDIENTE_CONTRATOS, descripcion: 'Pendiente Contratos' },
  { id: AUTORIZACIONES_PRESUPUESTOS_ESTADOS.AUTORIZADO, descripcion: 'Autorizado' },
  { id: AUTORIZACIONES_PRESUPUESTOS_ESTADOS.RECHAZADO, descripcion: 'Rechazado' },

];

export const AUTORIZACIONES_PRACTICAS_ESTADOS = {
  PENDIENTE: 1,
  AUTORIZADO: 2,
  RECHAZADO: 3,
  GESTION: 4,
  TERMINADA: 5,
};

export const AUTORIZACIONES_MATERIALES_ESTADOS = {
  PENDIENTE: 1,
  AUTORIZADO: 2,
  RECHAZADO: 3,
  GESTION: 4,
};

export const AUTORIZACIONES_MATERIALES_COMPRAS_ESTADOS = {
  PENDIENTE: 1,
  PRESUPUESTO: 2,
  COMPRA_DIRECTA: 3,
  REPOSICION: 4
};

export const AUTORIZACIONES_MENU_AUDITORIA = {
  AFILIADO: 0,
  ADMINISTRAR: 1,
  INFORMACION: 2,
  PRACTICAS: 3,
  NOTAS: 4,
  OBSERVACIONES: 5,
  PRACTICAS_PENDIENTES: 6,
  SOLICITUDES_REL: 7,
  EFECTOR_LABORATORIO: 8,
};

export const AUTORIZACIONES_TIPOS_NOTAS = {
  PRIVADA: 1,
  PUBLICA: 2,
  DEVOLUCION: 3,
  RECHAZO: 4,
};

export const AUTORIZACIONES_TIPOS_DOCUMENTACION = {
  ORDEN_MEDICA: 1,
  RESUMEN_HC: 2,
  ESTUDIOS_COMPLEMENTARIOS: 3,
  TRASLADOS: 4,
  PRESUPUESTO: 5,
};

export const AUTORIZACIONES_BANDEJAS = {
  AUDITOR_MEDICO: 1,
  AUDITOR_TRAUMATOLOGICO: 2,
  AUDITOR_ONCOLOGICO: 3,
  COMPRAS: 4,
  FISIATRIA: 5,
  /*DIRECCION_MEDICA: 6,*/
  JEFATURA_AUDITORIA_MEDICA: 7,
  AUDITORIA_ADMINISTRATIVA: 8,
  AUDITORIA_TERRENO: 9,
  INTERNACION_PAIS: 10,
  AUDITOR_PRESUPUESTOS: 11,
  CONTRATOS: 12,
  INTERNACION_DOMICILIARIA: 13,
  PRACTICAS_INTERNACION: 14,
  AFILIACIONES: 15,
  OTRAS: 16,
  OXIGENO: 17,
  ESTADIAS_Y_PASAJES: 18,
  GERENCIADORAS: 19,
  LABORATORIO: 20
};

export const AUTORIZACIONES_MENU_HISTORIAL = {
  SOLICITUD: 0,
  PRESUPUESTO: 0,
  PRACTICA: 1,
  MATERIAL: 2,
  PERIODO_PRACTICA: 3,
};

export const AUTORIZACIONES_TIPO_EFECTOR = {
  INSTITUCIONAL: 1,
  PROFESIONAL: 2,
  INSTITUCIONAL_Y_PROFESIONAL: 3,
  INSTITUCINOAL_DISPONIBLE: 4, //DENUNCIA INTERNACION
};

export const AUTORIZACIONES_COBRA_COSEGURO = {
  SI: 1,
  NO: 2,
  COBRA_CAB: 3,
};

export const ESPECIALIDADES = {
  LABORATORIO: 1197
}

export const PRACTICA_APERTURA_DENUNCIA_INTERNACION = {
  ID_COD_NOM: 5259,
  COD_NOM: '43.01.10',
  DES_NOM: 'APERTURA DENUNCIA DE INTERNACION',
};

export const PRACTICA_CIERRE_DENUNCIA_INTERNACION = {
  ID_COD_NOM: 5260,
  COD_NOM: '43.01.11',
  DES_NOM: 'CIERRE DENUNCIA DE INTERNACION',
};

export const PRACTICA_APERTURA_INTERNACION_DOMICILIARIA = {
  ID_COD_NOM: 8683,
  COD_NOM: '99.99.10',
  DES_NOM: 'APERTURA DE INTERNACION DOMICILIARIA',
};

export const PRACTICA_CIERRE_INTERNACION_DOMICILIARIA = {
  ID_COD_NOM: 8684,
  COD_NOM: '99.99.11',
  DES_NOM: 'CIERRE DE INTERNACION DOMICILIARIA',
};


export const PRACTICA_PASAJES = {
  ID_COD_NOM: 8692,
  COD_NOM: '99.99.12',
  DES_NOM: 'PRACTICA DE PASAJES',
};

export const PRACTICA_ESTADIAS = {
  ID_COD_NOM: 8693,
  COD_NOM: '99.99.13',
  DES_NOM: 'PRACTICA DE ESTADIAS',
};

export const TIPO_TRACKING_ABM = {
  NOMENCLADOR_BANDEJA: 1,
  EFECTOR_AUDITOR_TERRENO: 2,
  NOMENCLADOR_NACIONAL: 3,
  GRUPO_COSEGURO: 4,
};

export const MOTIVOS_BAJA_TURNOS = {
  CANCELADO_POR_AFILIADO: 20,
  CANCELADO_POR_PROFESIONAL: 2,
  ERROR_AGENDA_MEDICA: 3,
  VACACIONES: 8,
  FERIADO: 21,
};

export const GASTOS_NOMENCLADOR = [
  {
    id: 1,
    descripcion:  'Galeno',
  },
  {
    id: 2,
    descripcion:  'Gasto Quirurgico',
  },
  {
    id: 3,
    descripcion:  'Otros Gastos',
  },
  {
    id: 4,
    descripcion:  'Honorario Odontológico',
  },
  {
    id: 5,
    descripcion:  'Gasto Odontológico',
  },
  {
    id: 6,
    descripcion:  'Gasto Bioquímico',
  },
  {
    id: 7,
    descripcion:  'Gasto Radiológico',
  },
  {
    id: 8,
    descripcion:  'Sanatorio Pensión',
  },
  {
    id: 9,
    descripcion:  'Honorario Bioquímico',
  },
  {
    id: 10,
    descripcion:  'Gasto Odontológico Prot.',
  },
  {
    id: 11,
    descripcion:  'NBU',
  },
  {
    id: 12,
    descripcion:  'Gasto TAC',
  },
  {
    id: 13,
    descripcion:  'Gasto Ecográfico',
  },
];

//CATEGORIAS EFECRTOR
export const CATEGORIAS_EFECTOR = {
  GASTO_ASISTENCIAL: 3,
  PRESTADOR: 18,
  HONORARIOS_MCP: 62,
};

//RECLAMOS
export const MENU_RECLAMOS = {
  DESELECCIONAR: 0,
  INGRESO: 1,
  CONSULTA: 2,
  GESTION_EFECTOR: 3,
  ENVIADOS: 4,
  GESTION_EXTERNOS: 5
};

//HCE

export const MENU_HCE = {
  DESELECCIONAR: 0,
  LISTADO_PACIENTES: 1,
  REPORTES: 2,
  BUSQUEDA_POR_PACIENTE: 3
};

export const STEPPER_HCE_FORM = {
  RECLAMOS_INGRESO: 0,
  DATOS_RECLAMO: 1,
  DOCUMENTACION: 2,
  IMPRESION: 3,
};

export const STEPPER_HCE_EMPRADONAMIENTO = {
  DATOS_TITULAR: 0,
  DETALLE: 1,
  DOCUMENTACION: 2,
  MEDICAMENTOS: 3,
  CONFIRMACION: 4,
};

export const HCE_ESTADOS = {
  SIN_CONFIRMAR: 0,
  CONFIRMADOS: 1,
};

export const HCE_ESTADOS_PROBLEMAS = {
  ACTIVO: 1,
  ANTECEDENTES_PERSONALES: 2,
  RESUELTO: 3,
  ANTECEDENTES_FAMILIARES: 4,
  PROCEDIMIENTO: 5,
};

export const HCE_TIPOTURNOS = {
  VIDEOCONSULTA: 2,
  PRESENCIAL: 1,
};

export const HCE_MENU_INFORMACION = {
  DIAGNOSTICOS: 0,
  PROBLEMAS: 1,
  DOCUMENTACION: 2,
  ANALISIS_CLINICOS: 3,
  IMAGENES_PRESTADORES: 4,
  MEDICACION: 5,
  EMPADRONAMIENTO: 6,
  INFORMES: 7,
  RESUMEN: 8,
  ODONTOLOGIA: 9,
  TURNOS: 10,
  RECETAS: 11,
  MEDICACION_INDICADA: 12,
  ENFERMERIA: 13,
  ESTUDIOS_SOLICITADOS: 14,
  OFTALMOLOGIA: 15,
  CONSUMOS: 16,
  SOLICITUDES_PROFESIONAL: 17,
};

export const PARAMETROS_ARCHIVOS_EMPADRONAMIENTO = [
  {
    id: 1,
    descripcion:  'Oncologia',
  },
  {
    id: 2,
    descripcion:  'Diabetes',
  },
  {
    id: 3,
    descripcion:  'Cronicos',
  },
];

export const TIPOS_ARCHIVOS_EMPADRONAMIENTO_HCE = {
  ONCOLOGIA: 1,
  DIABETES: 2,
  CRONICOS: 3,
};



// MESA DE ENTRADA
export const MENU_MESA_ENTRADA = {
  DESELECCIONAR: 0,
  RECEPCION_COMPROBANTES: 1,
  GESTION_COMPROBANTES_PRESTADORES: 2,
  GESTION_COMPROBANTES_DOCUMENTO: 3,
  GESTION_COMPROBANTES_OSPE_DIRECTO: 4,
  BUSCADOR_EXPEDIENTES: 5
};

export const MESA_ENTRADA_COMPROBANTES_ESTADOS = {
  PENDIENTE_ENVIO: 1,
  ANULADA: 2,
  ENVIADA: 3,
  PROFORMA: 4,
};

export const MESA_ENTRADA_OFERENTE = {
  PRESTADORES: 1,
  PROVEEDORES: 2,
};

export const MESA_ENTRADA_OFERENTE_ARRAY = [
  { 
    id: MESA_ENTRADA_OFERENTE.PRESTADORES,
    descripcion: 'Prestadores',
    value: false ,
  },
  { 
    id: MESA_ENTRADA_OFERENTE.PROVEEDORES,
    descripcion: 'Proveedores',
    value: true ,
  },
];

export const ESTADOS_COMRPOBANTES = {
  PENDIENTE_ENVIO: 1,
  ANULADA: 2,
  ENVIADA: 3,
  RETORNADA: 8,
  PROFORMA_ENVIADA: 10,
  PROFORMA_PAGADA: 11,
  PROFORMA_IMPUTADA: 12,
  PROFORMA_ASIGNADA: 13,
};

export const MESA_ENTRADA_GESTION_BUTTONS = {
  ENVIAR: 0,
  MODIFICAR_DESTINO: 1,
  RETORNAR: 2,
};

export const CONDICION_IVA = {
  RESPONSABLE_INSCRIPTO: 1,
  MONOTRIBUTO: 2,
  EXENTO: 3,
  NO_RESPONSABLE: 4,
  MONOTRIBUTISTA_SOCIAL: 5,
};

export const CONDICION_IVA_ARRAY = [
  { id: CONDICION_IVA.RESPONSABLE_INSCRIPTO, descripcion: 'Responsable Inscripto' },
  { id: CONDICION_IVA.MONOTRIBUTO, descripcion: 'Monotributo' },
  { id: CONDICION_IVA.EXENTO, descripcion: 'Exento' },
  { id: CONDICION_IVA.NO_RESPONSABLE, descripcion: 'No Responsable' },
  { id: CONDICION_IVA.MONOTRIBUTISTA_SOCIAL, descripcion: 'Monotributista Social' },
];

export const PROVINCIAS = {
  CABA: 24,
};

export const MOTIVO_BAJA_AFI = {
  FIN_DE_CONTRATO: 41,
  TRABAJADOR_TEMPORADA_RESERVA_PUESTO: 49,
};

export const DATOS_EXPEDIENTE = {
  TRAMITE: 1,
  DESTINO: 2,
};

export const MENU_TIPO_EXPEDIENTE = {
  DESELECCIONAR: 0,
  PRESTADOR: 1,
  DOCUMENTO: 2,
};

export const MENU_TIPO_EXPEDIENTE_ARRAY = [
  {  id: MENU_TIPO_EXPEDIENTE.PRESTADOR, descripcion: 'Comprobante Contratos'  },
  {  id: MENU_TIPO_EXPEDIENTE.DOCUMENTO, descripcion: 'Comprobante Documento'  },
];

export const DATOS_COMPROBANTE = {
  TIPO_COMPROBANTE: 1,
  TIPO_FACTURA: 2,
  PROCEDENCIA: 3,
};

export const DESTINOS_COMPROBANTE =  {
  LIQUIDACIONES: 1,
  LEGALES: 2,
  TESORERIA: 3,
  RRHH: 4,
  COMPRAS: 5,
  SECRETARIA_OSPEDYC: 6,
  SECRETARIA_ADMINISTRATIVA: 7,
  AFILIACIONES: 8,
  REINTEGRO_SUR: 9,
  TESORERIA_INTEGRACION: 10,
  AUDITORIA_MEDICA: 11,
  MESA_ENTRADA: 12,
};

export const TRAMITE_COMPROBANTE_DOCUMENTO = {
  CARTA_DOCUMENTO: 1,
  CARTA_DOCUMENTO_HOSPITALES: 2,
  CEDULA_NOTIFICACION: 3,
  DEFENSORIA_PUEBLO: 4,
  DEFENSA_CONSUMIDOR: 5,
  NOTA: 7,
  NOTA_SSS: 8,
  OFICIO_JUDICIAL: 9,
  TELEGRAMA: 11,
  DOCUMENTACION_AFILIACIONES: 22,
  DOCUMENTACION_COMPRAS: 23,
  DOCUMENTACION_TESORERIA: 24,
  DOCUMENTACION_SECRETARIA: 25,
  DOCUMENTACION_SUR: 26,
  DOCUMENTACION_RRHH: 27,
  EMBARGO: 29,
  REINTEGRO: 30,
};

export const TRAMITE_COMPROBANTE_DOCUMENTO_ARRAY = [
  { id: TRAMITE_COMPROBANTE_DOCUMENTO.CARTA_DOCUMENTO, descripcion: 'Carta documento' },
  { id: TRAMITE_COMPROBANTE_DOCUMENTO.CARTA_DOCUMENTO_HOSPITALES, descripcion: 'Carta documento Hospitales' },
  { id: TRAMITE_COMPROBANTE_DOCUMENTO.CEDULA_NOTIFICACION, descripcion: 'Cédula de notificación' },
  { id: TRAMITE_COMPROBANTE_DOCUMENTO.DEFENSORIA_PUEBLO, descripcion: 'Defensoría del pueblo' },
  { id: TRAMITE_COMPROBANTE_DOCUMENTO.DEFENSA_CONSUMIDOR, descripcion: 'Defensa del consumidor' },
  { id: TRAMITE_COMPROBANTE_DOCUMENTO.NOTA, descripcion: 'Nota' },
  { id: TRAMITE_COMPROBANTE_DOCUMENTO.NOTA_SSS, descripcion: 'Nota SSS' },
  { id: TRAMITE_COMPROBANTE_DOCUMENTO.OFICIO_JUDICIAL, descripcion: 'Oficio judicial' },
  { id: TRAMITE_COMPROBANTE_DOCUMENTO.TELEGRAMA, descripcion: 'Telegrama' },
  { id: TRAMITE_COMPROBANTE_DOCUMENTO.DOCUMENTACION_AFILIACIONES, descripcion: 'Documentación Afiliaciones' },
  { id: TRAMITE_COMPROBANTE_DOCUMENTO.DOCUMENTACION_COMPRAS, descripcion: 'Documentación Compras' },
  { id: TRAMITE_COMPROBANTE_DOCUMENTO.DOCUMENTACION_TESORERIA, descripcion: 'Documentación Tesoreria' },
  { id: TRAMITE_COMPROBANTE_DOCUMENTO.DOCUMENTACION_SECRETARIA, descripcion: 'Documentación Secretaria' },
  { id: TRAMITE_COMPROBANTE_DOCUMENTO.DOCUMENTACION_SUR, descripcion: 'Documentación SUR' },
  { id: TRAMITE_COMPROBANTE_DOCUMENTO.DOCUMENTACION_RRHH, descripcion: 'Documentación RRHH' },
  { id: TRAMITE_COMPROBANTE_DOCUMENTO.EMBARGO, descripcion: "Embargo" },
  { id: TRAMITE_COMPROBANTE_DOCUMENTO.REINTEGRO, descripcion: "Reintegro" },
]

export const TRAMITE_COMPROBANTE_FACTURACION_PRESTADORES = {
  DIRECTORES_MEDICOS: 12,
  PRESTADORES: 13,
  PRESTADORES_HOSPITALES_PUBLICOS: 16,
  INTEGRACION: 28,
};

export const TRAMITE_COMPROBANTE_FACTURACION_PRESTADORES_ARRAY = [
  { id: TRAMITE_COMPROBANTE_FACTURACION_PRESTADORES.DIRECTORES_MEDICOS, descripcion: 'Facturación Directores Médicos' },
  { id: TRAMITE_COMPROBANTE_FACTURACION_PRESTADORES.PRESTADORES, descripcion: 'Facturación Prestadores' },
  { id: TRAMITE_COMPROBANTE_FACTURACION_PRESTADORES.PRESTADORES_HOSPITALES_PUBLICOS, descripcion: 'Facturación Prestadores Hospitales  Públicos' },
  { id: TRAMITE_COMPROBANTE_FACTURACION_PRESTADORES.INTEGRACION, descripcion: 'Facturacion prestadores de integracion' }
]

export const TRAMITE_COMPROBANTE_FACTURACION_PROVEEDORES = {
  PROVEEDORES: 14,
  COMPRAS_INSUMOS_MEDICOS: 15,
  SERVICIOS_COMPRAS: 17,
  SERVICIOS_SISTEMAS: 18,
  SERVICIOS_TESORERIA: 19,
  RECIBO: 20,
};

export const TRAMITE_COMPROBANTE_FACTURACION_PROVEEDORES_ARRAY = [
  { id: TRAMITE_COMPROBANTE_FACTURACION_PROVEEDORES.PROVEEDORES, descripcion: 'Facturación Proveedores' },
  { id: TRAMITE_COMPROBANTE_FACTURACION_PROVEEDORES.COMPRAS_INSUMOS_MEDICOS, descripcion: 'Facturación Compras-Insumos Médicos' },
  { id: TRAMITE_COMPROBANTE_FACTURACION_PROVEEDORES.SERVICIOS_COMPRAS, descripcion: 'Facturación de Servicios Compras' },
  { id: TRAMITE_COMPROBANTE_FACTURACION_PROVEEDORES.SERVICIOS_SISTEMAS, descripcion: 'Facturación de servicios Sistemas' },
  { id: TRAMITE_COMPROBANTE_FACTURACION_PROVEEDORES.SERVICIOS_TESORERIA, descripcion: 'Facturación de servicios Tesorería' },
  { id: TRAMITE_COMPROBANTE_FACTURACION_PROVEEDORES.RECIBO, descripcion: 'Recibo' },
]

export const LETRA_TIPO_FACTURA = {
  B: 2,
  C: 3,
};

export const LETRA_TIPO_FACTURA_AFIP = {
  B: 6,
  C: 11,
};

export const STEPPER_EXPEDIENTE_FORM = {
  TRAMITE_COMPROBANTE: 0,
  DATOS_COMPROBANTE: 1,
  DOCUMENTACION: 2,
  IMPRESION: 3,
};

export const STEPPER_EXPEDIENTE_CONTABLES_FORM = {
  TRAMITE_COMPROBANTE: 0,
  DATOS_COMPROBANTE: 1,
  ASIENTOS_CONTABLES: 2,
  DOCUMENTACION: 3,
  IMPRESION: 4,
};

export const STEPPER_EXPEDIENTE_PROFORMA_FORM = {
  TRAMITE_COMPROBANTE: 0,
  PROFORMAS_PENDEINTES: 1,
  DATOS_COMPROBANTE: 2,
  DOCUMENTACION: 3,
  IMPRESION: 4,
};

export const STEPPER_EXPEDIENTE_CONTABLES_PROFORMA_FORM = {
  TRAMITE_COMPROBANTE: 0,
  PROFORMAS_PENDEINTES: 1,
  DATOS_COMPROBANTE: 2,
  ASIENTOS_CONTABLES: 3,
  DOCUMENTACION: 4,
  IMPRESION: 5,
};

export const TIPO_DOCUMENTACION_COMPROBANTE = {
  PRESTADORES_PROVEEDORES: 68,
  DOCUMENTO: 69,
};

export const MODULOS_APLICACION = {
  MESA_ENTRADA: 3,
  RECLAMOS: 4,
  HCE: 6,
  HCE_ODONTOLOGIA: 8,
  RECLAMOS_EFECTORES: 9,
  RECLAMOS_EXTERNOS: 10,
  EMPADADRONAMIENTO_HCE: 11
};

export const MENU_INFORMACION_EXPEDIENTES = {
  DATOS_TRAMITE: 0,
  DATOS_COMPROBANTE_PRESTADORES: 1,
  DATOS_COMPROBANTE_DOCUMENTO: 2,
  DATOS_CARGA: 3,
  DOCUMENTACION: 4,
  DATOS_PRESTADOR_PROVEEDOR: 5,
};

export const ESTADO_MEDICACION_310 = {
  VIGENTES: 1,
  NO_VIGENTES: 2,
  TODOS: 3,
};

export const TIPO_EMPADRONAMIENTO = {
  CELIAQUIA: 1,
  DIABETES: 2,
  DISCAPACIDAD: 3,
  HIPERTENSION: 4,
  HIV: 5,
  LECHES_MATERNIZADAS: 6,
  PACBI: 7,
  MEDICACION_CRONICA_100: 8,
  MEDICACION_CRONICA_70: 9,
  MEDICACION_CRONICA_40: 10,
  ONCOLOGIA: 11,
  DROGADEPENDENCIA: 12,
};

export const CONVENIO_SCIENZA = {
  COVERTURA_100: 1,
  SUR: 2,
  NA_SUR: 113,
  NA_COBERTURA_100: 114
};

export const STEPPER_EMPADRONAMIENTO = {
  BUSCAR_TITULAR: 0,
  DATOS_TITULAR: 1,
  DETALLE: 2,
  DOCUMENTACION: 3,
  MEDICAMENTOS: 4,
  CONFIRMACION: 5,
};

export const STEPPER_MEDICACION = {
  BUSCAR_TITULAR: 0,
  DATOS_TITULAR: 1,
  DETALLE: 2,
  DOCUMENTACION: 3,
  MEDICAMENTOS: 4,
  CONFIRMACION: 5,
};

export const EMPADRONAMIENTO_SOLICITUDES_ESTADOS = {
  EN_CARGA: 1,
  PENDIENTE_REVISION: 2,
  PENDIENTE_AUTORIZACION: 3,
  RECHAZADA: 5,
  ACTIVA: 4,
  INACTIVA: 6,
  ANULADA: 7
};

export const EMPADRONAMIENTO_MEDICACION_ESTADOS = {
  EN_CARGA: 1,
  PENDIENTE_REVISION: 2,
  PENDIENTE_AUTORIZACION: 3,
  RECHAZADA: 5,
  AUTORIZADA: 4,
  ANULADA: 6
};

export const STEPPER_RECETAS = {
  BUSCAR_TITULAR: 0,
  DATOS_TITULAR: 1,
  DETALLE_RECETA: 2,
  MEDICAMENTOS: 3,
  CONFIRMACION: 4,
};

export const TIPOS_RECETAS = {
  RECETA: 1,
  PRESCRIPCION: 3,
  CERTIFICADO: 4
};

export const SUBTIPOS_RECETAS = {
  CERTIFICADO: 1,
  INDICACION: 2,
  RECETA: 3,
};

export const RECETAS_ESTADOS = {
  EN_CARGA: 1,
  GENERADAS: 2,
};

export const RECETAS_MENU_GESTION = {
  AFILIADO: 0,
  ADMINISTRAR: 1,
  INFORMACION: 2,
  PRACTICAS: 3,
  NOTAS: 4,
  OBSERVACIONES: 5,
};

export const EMPADRONAMIENTO_MENU_GESTION = {
  AFILIADO: 0,
  ADMINISTRAR: 1,
  INFORMACION: 2,
  DOCUMENTACION: 3,
  MEDICACION: 4,
  NOTAS : 5
};
export const EMPADRONAMIENTO_MENU_HISTORIAL ={
  SOLICITUD :0,
  ENVIOS : 1,
  NOSCONECTA: 2
}

export const MENU_EMPADRONAMIENTO = {
  INGRESO_SOLICITUD: 1,
  GESTION_BANDEJA: 2,
  CONSULTA_EMPADRONAMIENTOS: 3,
};

export const EMPADRONAMIENTO_TIPOS_NOTAS = {
  PRIVADA: 1,
  DEVOLUCION: 2,
  RECHAZO: 3,
  AUTORIZACION: 4,
  FINALIZACION: 5,
  ANULACION: 6
};

export const MENU_RECETAS = {
  INGRESO_RECETA: 1,
  GESTION_HISTORIAL: 2,
};

export const ROLES = {
  RECETAS_DIGITALES: 50,
  TOTEM: 56,
};


export const ESTADOS_COTIZACIONES = {
  PENDIENTE_COTIZACION: 1, //corresponde al id de estado de autorizacion solicitudes
  COTIZACIONES_SOLICITADAS: 2,
  PENDIENTE_ACEPTACION: 3,
  COTIZACIONES_ACEPTADAS: 4,
  ANULADAS:6
};

export const ESTADOS_AUDITORIAFACTURACION_COMPRAS = {
  COMPROBANTE: 1,
  PENDIENTE_ENVIO: 2,
  PENDIENTE_PAGO: 3,
  RECHAZADAS: 4,
  PAGADAS:5,
};
export const PROCEDENCIA = {
  CORREO: 1,
  MANO: 2,
  OTRAS_AREAS: 3,
  MAIL: 4,
  ALBERTI: 5,
  MEXICO: 6,
};

export const MODULO_APLICACION = {
  AFILIACIONES: 1,
  CONTRATACIONES: 2,
  MESA_ENTRADA: 3,
};

export const TIPO_COMPROBANTE_DOCUMENTO = {
  DOCUMENTACION: 1,
  EMBARGO: 2,
};

export const COMPROBANTE_EMBARGO_ARRAY = [
  {
     descripcion: 'Documentación',
    value: TIPO_COMPROBANTE_DOCUMENTO.DOCUMENTACION,
   },
  {  descripcion: 'Embargo', value: TIPO_COMPROBANTE_DOCUMENTO.EMBARGO  },
];

export const AREAS_FISICAS = {
  LIQUIDACIONES: 1,
  LEGALES: 2,
  TESORERIA: 3,
  RRHH: 4,
  COMPRAS: 5,
  SECRETARIA_OSPEDYC: 6,
  SECRETARIA_ADMINISTRATIVA: 7,
  AFILIACIONES: 8,
  REINTEGRO_SUR: 9,
  TESORERIA_INTEGRACION: 10,
  AUDITORIA_MEDICA: 11,
  MESA_ENTRADA: 12,
  MESA_AYUDA: 20,
  COMUNICACIONES: 16,
};

export const SUB_AREAS_FISICAS = {
  ALBERTI: 1,
  MATHEU: 2,
};

export const HISTORIAL_COTIZACIONES =  {
  COTIZACIONES: 1,
  MATERIALES: 2,
};

//RECLAMOS

export const MENU_TIPO_INGRESO_RECLAMO = {
  DESELECCIONAR: 0,
  AFILIADO: 1,
  PRESTADOR: 2,
  EXTERNOS: 3
};

export const MENU_TIPO_INGRESO_RECLAMO_ARRAY = [
  { id: MENU_TIPO_INGRESO_RECLAMO.AFILIADO, descripcion: 'Ingreso Beneficiaria/o' },
  { id: MENU_TIPO_INGRESO_RECLAMO.PRESTADOR, descripcion: 'Ingreso Efector' },
  { id: MENU_TIPO_INGRESO_RECLAMO.EXTERNOS, descripcion: 'Ingreso Externos' },
];

export const MENU_TIPO_RECLAMO = {
  RECLAMO: 0,
  CONSULTA: 1,
  DISCONFORMIDAD: 2,
  SUGERENCIAS: 3,
  GESTIONES_POR_EXCEPCION: 4,
  AGRADECIMIENTOS: 5,
};

export const TIPO_COMENTARIOS_RECLAMOS = {
  PRIVADO: 1,
  PUBLICO: 2,

};

export const MENU_TIPO_RECLAMOS_ARRAY = [
  { id: 0, descripcion: 'Reclamo' },
  { id: 1, descripcion: 'Consulta' },
  { id: 2, descripcion: 'Disconformidad' },
  { id: 3, descripcion: 'Sugerencias' },
  { id: 4, descripcion: 'Gestiones por excepcion' },
  { id: 5, descripcion: 'Agradecimientos' }
];

export const ORIGEN_RECLAMO = {
  WEB: 0,
  TELEFONICO: 1,
  MAIL: 2,
  GERENCIAS: 3,
  SECCIONAL: 4,
  FACEBOOK: 5,
};

export const ORIGEN_RECLAMOS_ARRAY = [
  { id: 0, descripcion: 'Web' },
  { id: 1, descripcion: 'Telefonico' },
  { id: 2, descripcion: 'Mail' },
  { id: 3, descripcion: 'Gerencias' },
  { id: 4, descripcion: 'Seccional' },
  { id: 5, descripcion: 'Facebook' }
];

export const STEPPER_RECLAMOS_FORM = {
  RECLAMOS_INGRESO: 0,
  DATOS_RECLAMO: 1,
  DOCUMENTACION: 2,
  IMPRESION: 3,
};

export const TIPO_DOCUMENTACION_RECLAMOS = {
  DOCUMENTO: 72,
};

export const TIPO_DOCUMENTACION_RECLAMO_EFECTOR = {
  DOCUMENTO: 99,
};

export const TIPO_DOCUMENTACION_RECLAMO_EXTERNO = {
  DOCUMENTO: 100,
};

export const RECLAMOS_ESTADOS = {
  FINALIZADA: 2,
  PENDIENTE: 1,
  ANULADA: 3
};



export const TIPO_DOCUMENTACION_HCE = {
  ESTUDIOS_MEDICOS: 79,
  ANALISIS: 80,
  OTROS: 81,
};

export const TIPO_DOCUMENTACION_EMPADRONAMIENTO_HCE = {
  ONCOLOGIA: 101,
  DIABETES: 102,
  CRONICOS: 103,
};


export const TIPO_DOCUMENTACION_ODONTO = {
  ODONTOGRAMA: 98,
};

export const RECLAMOS_MENU_INFORMACION = {
  AFILIADO: 0,
  INFORMACION: 1,
  DOCUMENTACION: 2,
  DERIVACIONES: 3,
  EFECTOR: 4
};


export const RECLAMOS_MENU_EFECTOR_INFORMACION = {
  EFECTOR: 0,
  INFORMACION: 1,
  DOCUMENTACION: 2,
  DERIVACIONES: 3
};

export const RECLAMOS_MENU_EXTERNO_INFORMACION = {
  EXTERNO: 0,
  INFORMACION: 1,
  DOCUMENTACION: 2,
  DERIVACIONES: 3
};

export const MENU_IMPRESION_RECLAMOS_ARRAY = [
  { id: 1, descripcion: 'Imprimir' },
  { id: 2, descripcion: 'Envío mail novedades sobre el caso'}
];

export const ESTADOS_BANDEJAS_SUSPENSION = {
  PENDIENTES: 1,
  CONTESTADOS: 2,
  CASOS_CERRADOS: 3
}

export const ESTADO_VALORIZACIONES_DISCAPACIDAD = {
  VIGENTES: 1,
  NO_VIGENTES: 2,
  TODOS: 3
}

export const ESTADO_BANDEJA_COMPROBANTES_COMPRAS = {
  COMPROBANTES: 1,
  AUDITORIA_MEDICA: 2,
  PENDIENTE_PAGO: 3,
  RECHAZADAS: 4
}

export const OBRAS_SOCIALES = {
  OSPEDYC: 1,
  OSOCNA: 2,
  OSPCYD: 3,
  OSPAVIAL: 4
}

export const MENU_TOTEM = {
  DESELECCIONAR: 0,
  SOLICITUDES_RECEPCIONISTA: 1,
  GESTION_AREAS_RECEPCIONISTA: 2,
  CARGA_SOLICITUD_AFILIADO: 3
};

export const TIPO_INGRESO_MESA_ENTRADA = {
  PRESTADOR_PROVEEDOR: 1,
  DOCUMENTACION: 2

}

export const REMITOS_GENERADOS = {
  SIN_GENERAR: 1,
  GENERADOS: 2

}

export const TIPO_NOTA_SOLICITUD_INTEGRACION = {
  RECHAZO: 1,
  DEVOLUCION: 2,
  PUBLICA: 3,
  PRIVADA: 4,
}

export const MENU_HISTORIAL_CONSUMO = {
  AUTORIZACIONES: 0,
  DISCAPACIDAD: 1,
  PRESUPUESTOS: 2
};

export const MENU_HISTORIAL_CONSUMO_EMP = {
  EMPADRONAMIENTO: 0,
  MEDICACION: 1,
  MIGRACION: 2
};

export const MENU_CERTIFICADO_ATENCION = {
  INGRESO_CERTIFICADO: 1,
  BUSQUEDA_CERTIFICADO: 2,
};

export const STEPPER_CERTIFICADO_DIGITAL = {
  BUSCAR_TITULAR: 0,
  DATOS_TITULAR: 1,
  DETALLE_CERTIFICADO: 2,
  CONFIRMACION: 3,
};

export const LIQUIDACIONES_EXCEL_TIPOCONSULTA = {
  PRESTACION: 1,
  INSUMO: 2,
  MEDICAMENTO: 3,
};

export const BUSCADOR_MESA_ENTRADAS = {
  POR_ID_EXPEDIENTE: 1,
  POR_ID_EXPEDIENTE_SV: 2,
  POR_NRO_FACTURA: 3,
  POR_ID_EFECTOR: 4
};

export const ESTUDIOS_MEDICOS_ESTADOS = {
  PENDIENTES_ESTUDIO: 1,
  PENDIENTES_INFORME: 2,
  ENVIADOS: 3
};

export const ESTUDIOSMEDICOS_MENU_GESTION = {
  AFILIADO: 0,
  ADMINISTRAR: 1,
  INFORMACION: 2,
  INFORMES: 3,
  NOTAS: 4,
  OBSERVACIONES: 5,
};

export const ESTUDIOS_MEDICOS_TIPO_NOTAS = {
  PRIVADA: 1,
  PUBLICA: 2,
};

export const SURGE_CARGA_IMAGENES_BUSQUEDA = {
  ALTO_COSTO: 1,
  MATERIALES_IMPLANTABLES: 2,
  SOLICITUDES: 3,
  SOL_DE_PAGO_CON_OP_RECIBOS_Y_RETENCIONES: 4, 
  SOL_DE_PAGO_LIQUIDACIONES: 5,
  HIV: 6
};

export const SURGE_BANDEJA_IMAGENES_MENU = {
  AFILIADO: 0,
  INFORMACION: 1,
  NOTAS: 2
};

export const TIPOS_ESTUDIOS_MEDICOS = {
  MAPA: 8,
  HOLTER: 10,
}
